<div class="narrow-panel-container">
    <div class="narrow-panel-header">
        <div class="content-title-1">
            Address Found
        </div>
        <button
                class=""
                (click)="close()"
                mat-icon-button
                aria-label="close"
        >
            <mat-icon class="action-icon">close</mat-icon>
        </button>
    </div>

    <div class="narrow-panel-section">
      @if (address) {
        <div class="content-title-1">
          {{ address.name }}
        </div>
        <div class="content-title-2">
          {{ address.formatted_address }}
        </div>
        <div class="content-title-3">
          Most recent service times:
        </div>
        @if (addressVisits && addressVisits.length > 0) {
          <div>
            @for (visit of addressVisits; track $index) {
              <div class="address-visit">
                <mat-icon class="timer-icon">timer</mat-icon>
                <div>
                  <span>{{ visit.time | date:'shortTime' }}</span>&nbsp;
                  @if (isOlderThanToday(visit.time)) {
                    <span>{{ visit.time | date:'fullDate' }}</span>
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (addressVisits && addressVisits.length === 0) {
          <div>
            No results in last {{ recentSearchRangeHours }} hours
          </div>
        }
        @if (!addressVisits) {
          <div>
            <mat-spinner></mat-spinner>
          </div>
        }
        <div class="button-wrapper">
          <button mat-button
                  color="accent"
                  [routerLink]="['/' + RootRoute.MAIN, MainRoute.INSIGHTS, 'address-lookup']"
                  [queryParams]="getAddressLookupSearchParams()"
                  [queryParamsHandling]="'merge'"
          >
            More details
          </button>
        </div>
      }
    </div>
</div>
